/* Maison Fermoir — transmet à Microsoft Clarity le choix fait dans le bandeau de cookies,
 * et rebranche le lien « Préférences cookies » du pied de page (refait le 09/10/2026)
 *
 * 🔄 09/10/2026 — PANDECTES REMPLACÉ PAR LE BANDEAU NATIF DE SHOPIFY.
 *   Pandectes n'écrivait pas dans l'API de confidentialité de Shopify : `_tracking_consent`
 *   restait absent après « Accepter », et l'API rendait "yes" par DÉFAUT à tout ce qui la
 *   lisait — Simprosys compris, qui envoyait donc les achats à Google en « accordé » même
 *   après un refus. Et son forfait gratuit ne permettait plus de rouvrir le bandeau
 *   (mise à jour de l'app du 08/10). Le bandeau natif écrit dans l'API : la source de
 *   vérité est désormais `Shopify.customerPrivacy`, plus aucun cookie d'app.
 *   La balise Google posée à la main dans le thème est RETIRÉE le même jour : Simprosys,
 *   qui lit l'API, est la seule source de balises Google (il déconseille toute autre).
 *
 * ⚠ POURQUOI CE FICHIER EXISTE ENCORE. Clarity ne se branche automatiquement qu'aux
 *   bandeaux qu'il reconnaît (au 22/09/2026, la documentation Microsoft n'en liste qu'un,
 *   CookieYes). Sans ce fichier il se croit autorisé : mesuré le 22/09, `consentStatus`
 *   à "granted" sans aucun choix fait.
 *
 * ⚠ LES CLÉS PORTENT UNE MAJUSCULE AU MILIEU : `ad_Storage`, `analytics_Storage`.
 *   C'est la signature de l'API `consentv2` de Microsoft. En minuscules l'appel est
 *   ignoré, sans erreur.
 *
 * ⚠ EN CAS DE DOUTE, ON REFUSE. Tout état inconnu vaut refus pour la publicité.
 */
(function () {
  'use strict';

  var ATTENTE = 250;   // ms entre deux tentatives
  var MAX = 60;        // ~15 s, au-delà on renonce sans bruit

  function direAClarity(publicite) {
    var essais = 0;
    (function tenter() {
      if (typeof window.clarity === 'function') {
        /* 04/10/2026 — DÉCISION DE MIKA : la mesure Clarity est toujours "granted",
           accord ou pas (sans cookie, Clarity coupait un replay par page). La
           publicité suit le bandeau. La politique de confidentialité et la page
           cookies le DISENT : ne jamais changer l'un sans l'autre
           (politiques/README.md). */
        window.clarity('consentv2', {
          ad_Storage: publicite ? 'granted' : 'denied',
          analytics_Storage: 'granted'
        });
        return;
      }
      if (++essais < MAX) setTimeout(tenter, ATTENTE);
    })();
  }

  /* Le choix enregistré chez Shopify. Avant toute réponse, dans une région où l'accord
     est requis, `marketingAllowed()` rend false : c'est le refus par défaut voulu. */
  function publiciteAutorisee() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed());
    } catch (e) {
      return false;
    }
  }

  function appliquer() {
    direAClarity(publiciteAutorisee());
  }

  /* L'API n'est pas forcément chargée quand ce fichier s'exécute : on la demande. */
  function chargerApi(suite) {
    if (window.Shopify && window.Shopify.customerPrivacy) return suite();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (err) { suite(err); }
      );
      return;
    }
    suite();
  }

  /* ⚠ COURSE MESURÉE LE 22/09 : un `consentv2` envoyé AVANT que Clarity ait fini de
     s'initialiser est PERDU, sans rien signaler. On réaffirme donc l'état plusieurs
     fois ; les appels sont idempotents. */
  chargerApi(function () {
    [0, 500, 1500, 4000].forEach(function (d) { setTimeout(appliquer, d); });
  });

  /* Au moment où elle répond dans le bandeau. */
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = (e && e.detail) || {};
    direAClarity(!!d.marketingAllowed);
  });

  /* Le lien « Préférences cookies » du pied de page pointe `#reopenbanner` (l'ancre de
     Pandectes, le menu `footer` est une donnée d'admin). On le rebranche ici sur le
     panneau du bandeau natif plutôt que de toucher au menu : une visiteuse doit pouvoir
     retirer son accord aussi simplement qu'elle l'a donné. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a || !/#reopenbanner$/i.test(a.getAttribute('href'))) return;
    e.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  });
})();
